var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view',{key:_vm.$route.path}),(_vm.showModal())?_c('dara-modal-change-password',{attrs:{"user":_vm.getUser()}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }